import {ContractFactory, ethers} from 'ethers';
import Web3Modal from "web3modal";

export default async function(contractdata : {bytecode: string, abi: any[]}, args:any[]) {
    const web3Modal = new Web3Modal()
    const connection = await web3Modal.connect()
    const provider = new ethers.providers.Web3Provider(connection)
    const signer = provider.getSigner()

    const factory = new ContractFactory(contractdata.abi, contractdata.bytecode, signer);
    const hasArgs = contractdata.abi[0].inputs.length > 0;
    if(hasArgs) {
        return await factory.deploy(...args);
    }

    // console.log(contract.address);
    // console.log(contract.deployTransaction);
    return await factory.deploy();
}
